import { handleLocalStorage } from '@utils';

import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

const { setItem } = handleLocalStorage;

export const updateTimeout: TMiddleware = store => next => action => {
  const { login } = store.getState();
  if (checkActionsType(action, [loginActions.updateTimeout])) {
    const timeout = action.payload;
    setItem('verification', { ...login.verification, timeout });
  }
  return next(action);
};

export default updateTimeout;
